// Display ISO date (YYYY-MM-DD) as DD/MM/YYYY for UI; backend remains ISO.
export function fmtDate(iso) {
  if (!iso || typeof iso !== "string") return "";
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  return `${m[3]}/${m[2]}/${m[1]}`;
}
